<template>
  <div class="radioInputWrapper" :style="styles">
    <Field
      :name="name"
      :rules="validation"
      v-slot="{ value, errorMessage, handleChange, handleBlur }"
    >
      <label v-if="labelOnTop" :style="labelOnTopStyle" class="input-label">
        {{$t(label)}}
        <span v-if="validation && validation.includes('required')">*</span>
        <span v-else>{{$t('(optional)')}}</span>
      </label>

      <div class="inputWrapper">
        <div
          class="custom-control custom-radio radio-input"
          v-for="option in options"
          :key="option.value"
        >
          <input
            type="radio"
            class="custom-control-input"
            :id="option.value"
            :value="option.value"
            :checked="localSelected === option.value"
            @change="(e) => onRadioChange(e, handleChange)"
            @blur="handleBlur"
          />
          <label class="custom-control-label" :for="option.value">
            {{ $t(option.text) }}
          </label>
        </div>
      </div>

      <div class="validation-error" v-if="errorMessage">
        {{ $t(errorMessage) }}
      </div>
    </Field>
  </div>
</template>

<script>
import { Field } from 'vee-validate';

export default {
  name: "radio-input",
  components: {
    Field
  },
  data() {
    return {
      localSelected: this.selectedValue
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    selectedValue: {
      type: String,
      required: false,
      default: ""
    },
    validation: {
      type: String,
      required: false
    },
    styles:{
      type: Object,
      default: ()=>{}
    },
    label: {
      type: String,
      required: false
    },
    labelOnTop: {
      type: Boolean,
      default: false
    },
    labelOnTopStyle: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    onRadioChange(e, handleChange) {
      const newValue = e.target.value;
      handleChange(e); // update VeeValidate
      this.localSelected = newValue; // ✅ local data, not prop
      this.$emit("component-updated", {
        selectedValue: newValue,
      });
      this.$emit('update:modelValue', newValue); // update parent (v-model)
    }
  },
};
</script>

<style lang="scss" scoped>
$medium: 800px;
.radioInputWrapper {
  @media only screen and (max-width: $medium) {
    // margin-left: 30px;
    // margin-right: 20px;
  }
  .inputWrapper {
    display: flex;
    background: #FFFFFF;
    border: 1px solid var(--input-border-color);
    box-sizing: border-box;
    border-radius: 8px;
    height: 44px;
  }
}
// input[type="radio"] + label {
//   color: #C4C4C4;
// }
.custom-radio {
  padding-left: 35px;
  &:nth-child(1) {
    border-right: 1px solid var(--input-border-color);;
  }
}
input[type="radio"] + label:before {
  border: none;
  box-shadow: none !important;
  width: 14px;
  height: 14px;
  top: 3px;
  left: -32px;
}

.custom-control {
  display: flex;
  align-items: center;
  flex: 1;
  column-gap: 10px;
}

.custom-control-label {
  text-align: center;
  font: normal normal 300 16px/22px 'Plus Jakarta Sans';
  letter-spacing: 0px;
  color: #1B1B1B;
  opacity: 1;
}

.custom-control-label::after,
.custom-control-label::before {
  width: 14px;
  height: 14px;
  top: 0;
  left: -35px;
  margin-left: 10px;
  margin-top: 2px;
}
.custom-control-label::after {
  background-image: none !important;
  background-color: var(--color-4) !important;
}
.custom-control-input[type="radio"]:checked ~ .custom-control-label::before {
  background: var(--color-4);
  padding: 5px;
  border: 1px solid var(--color-4) !important;
}
.custom-checkbox-dop {
  position: absolute;
  bottom: 5px;
  right: 10px;
  .custom-control-label {
    &:after,
    &:before {
      left: -20px;
    }
  }
}
.custom-control-label::after,
.custom-checkbox .custom-control-label::before,
.custom-control-input[type="radio"] {
  background-color: transparent !important;
  width: 20px;
  height: 20px;
  border: 1px solid var(--color-4);
  border-radius: 50%;
}
</style>
